/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CommentRect2TextIcon20Solid = forwardRef('CommentRect2TextIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 5a3 3 0 0 1 3-3h9a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3h-2.571l-4.815 3.745A1 1 0 0 1 4 16.955V14a3 3 0 0 1-3-3V5Zm4 4a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5H5Zm-.75-2.25A.75.75 0 0 1 5 6h7a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75Z" }),
        React.createElement("path", { d: "m11.429 15-2.572 2h3l3.53 2.745a1 1 0 0 0 1.613-.79V17a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3v6.5a3.5 3.5 0 0 1-3.5 3.5h-2.071Z" })));
});
